import { WITHDRAW_LIST, PLAYER_BANK_DETAILS } from "./types";

const initialState = {
  accountStatement: null,
  withdrawList: null,
  bonusListing: null,
  bankDetails: { banks: [], count: 0, pagesize: 10 },
};

export default (state = initialState, actions) => {
  const { type, payload } = actions;
  switch (type) {
    case WITHDRAW_LIST:
      return {
        ...state,
        withdrawList: payload,
      };
    case PLAYER_BANK_DETAILS:
      return {
        ...state,
        bankDetails: payload,
      };
    default:
      return state;
  }
};
